import createSvgIcon from '@mui/material/utils/createSvgIcon';

export const CheckCircleIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="12" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0407 8.47486L10.488 16.7811C10.4273 16.8502 10.3542 16.9053 10.2732 16.9429C10.1922 16.9806 10.105 17 10.0169 17C9.92885 17 9.84167 16.9806 9.7607 16.9429C9.67972 16.9053 9.60662 16.8502 9.54585 16.7811L6.43535 13.3288C6.31289 13.1886 6.24463 13.0028 6.24463 12.8097C6.24463 12.6165 6.31289 12.4307 6.43535 12.2905C6.49612 12.2213 6.56921 12.1662 6.65019 12.1286C6.73117 12.0909 6.81835 12.0715 6.90645 12.0715C6.99454 12.0715 7.08172 12.0909 7.1627 12.1286C7.24368 12.1662 7.31677 12.2213 7.37754 12.2905L10.0249 15.2267L17.1136 7.44011C17.1743 7.37093 17.2474 7.31585 17.3284 7.27822C17.4094 7.24059 17.4966 7.22119 17.5847 7.22119C17.6728 7.22119 17.7599 7.24059 17.8409 7.27822C17.9219 7.31585 17.995 7.37093 18.0558 7.44011C18.1795 7.58062 18.2474 7.76833 18.2445 7.96265C18.2417 8.15698 18.1685 8.34229 18.0407 8.4785V8.47486Z"
      fill="white"
      stroke="white"
      strokeWidth="0.5"
    />
  </svg>,
  'CheckCircle',
);

export function CheckCircleSvg() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0407 8.47486L10.488 16.7811C10.4273 16.8502 10.3542 16.9053 10.2732 16.9429C10.1922 16.9806 10.105 17 10.0169 17C9.92885 17 9.84167 16.9806 9.7607 16.9429C9.67972 16.9053 9.60662 16.8502 9.54585 16.7811L6.43535 13.3288C6.31289 13.1886 6.24463 13.0028 6.24463 12.8097C6.24463 12.6165 6.31289 12.4307 6.43535 12.2905C6.49612 12.2213 6.56921 12.1662 6.65019 12.1286C6.73117 12.0909 6.81835 12.0715 6.90645 12.0715C6.99454 12.0715 7.08172 12.0909 7.1627 12.1286C7.24368 12.1662 7.31677 12.2213 7.37754 12.2905L10.0249 15.2267L17.1136 7.44011C17.1743 7.37093 17.2474 7.31585 17.3284 7.27822C17.4094 7.24059 17.4966 7.22119 17.5847 7.22119C17.6728 7.22119 17.7599 7.24059 17.8409 7.27822C17.9219 7.31585 17.995 7.37093 18.0558 7.44011C18.1795 7.58062 18.2474 7.76833 18.2445 7.96265C18.2417 8.15698 18.1685 8.34229 18.0407 8.4785V8.47486Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}
